import { Button, TextInput } from '~/components';
import { getTheme, styled } from '~/modules';

const smSpacing = getTheme('spacing.sm');

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

type FormColumnType = {
  width: string;
};
export const FormLeftColumn = styled.div<FormColumnType>`
  width: ${({ width }) => width};
`;

export const FormRightColumn = styled.div<FormColumnType>`
  width: ${({ width }) => width};
  margin-left: ${smSpacing}px;
`;

export const Input = styled(TextInput)``;

export const ButtonComponent = styled(Button)`
  width: 100%;
  margin: auto;
`;
